import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { MeterUsageWrite, SettlementMeterUsage } from '../types'

/** Fills a usage row per meter from the nearest recorded readings. */
export function useAutofillMeterUsages() {
  return useSettlementMutation<string, SettlementMeterUsage[]>({
    toastKey: 'settlementUsagesAutofilled',
    request: async (id) =>
      (
        await apiClient.post<SettlementMeterUsage[]>(
          `${settlementsUrl}/${id}/meter-usages/autofill`,
          {}
        )
      ).data
  })
}

export function useCreateMeterUsage() {
  return useSettlementMutation<
    { id: string; body: MeterUsageWrite },
    SettlementMeterUsage
  >({
    toastKey: 'settlementUsageCreated',
    request: async ({ id, body }) =>
      (
        await apiClient.post<SettlementMeterUsage>(
          `${settlementsUrl}/${id}/meter-usages`,
          body
        )
      ).data
  })
}

export function useUpdateMeterUsage() {
  return useSettlementMutation<
    { id: string; usageId: string; body: Partial<MeterUsageWrite> },
    SettlementMeterUsage
  >({
    toastKey: 'settlementUsageUpdated',
    request: async ({ id, usageId, body }) =>
      (
        await apiClient.patch<SettlementMeterUsage>(
          `${settlementsUrl}/${id}/meter-usages/${usageId}`,
          body
        )
      ).data
  })
}

export function useDeleteMeterUsage() {
  return useSettlementMutation<{ id: string; usageId: string }, void>({
    toastKey: 'settlementUsageDeleted',
    request: async ({ id, usageId }) => {
      await apiClient.delete(`${settlementsUrl}/${id}/meter-usages/${usageId}`)
    }
  })
}
